import { InjectionToken } from '@angular/core';
import { PipelineBoardServiceConfig } from './interfaces';

export const PIPELINE_BOARD_SERVICE_CONFIG_TOKEN = new InjectionToken<PipelineBoardServiceConfig>(
  'general dependency data for the pipeline board',
);

export const SALESPERSON_ID_TOKEN = new InjectionToken<string>('Salesperson ID for use in the pipeline board service');
